import React from "react";
import FilterByMonthYear from "../../components/Filters/FilterByMonthYear";
import { MenuItem, Select } from "@mui/material";
import OnboardingOrientationTable from "../../components/Dashboard/Tables/OnboardingOrientationTable";
import { SelectInputStyle } from "../../components/Dashboard/Tables/Styles";

function OnboardingOrientation() {
  const [status, setStatus] = React.useState("showAll");

  const handleChange = (event) => {
    setStatus(event.target.value);
  };

  return (
    <div>
      <div className="flex justify-end gap-4 flex-col md:flex-row bg-white p-4">
        <FilterByMonthYear />

        <div className="flex gap-4 items-center ">
          <p className="text-[#98A2B3] font-['inter'] font-[500] text-[12px]">
            Status:
          </p>
          <Select
            value={status}
            onChange={handleChange}
            className="w-[190px] h-12 py-3 px-4"
            sx={SelectInputStyle}
          >
            <MenuItem value={"showAll"}>Show All</MenuItem>
            <MenuItem value={"completed"}>Completed</MenuItem>
            <MenuItem value={"pending"}>Pending</MenuItem>
          </Select>
        </div>
      </div>
      <OnboardingOrientationTable />
    </div>
  );
}

export default OnboardingOrientation;
